import axios from 'axios'
import store from '@/store'
import qs from 'qs'
import { Loading } from 'element-ui'
import Message from '@/utils/message'
import { logout } from '@/utils/logout'

let loadingInstance = null;
axios.defaults.timeout = 15000; // 响应时间
axios.defaults.withCredentials = true;
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';

axios.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers.common['Authorization'] = store.getters.token.token_type + ' ' + store.getters.token.access_token;
  }
  return config
}, error => {
  Promise.reject(error)
});

axios.interceptors.response.use(response =>{
  if (response.status !== 200){
    return Promise.reject(response);
  }
  return response;
}, error => {
  if(error.response.status == 424&&error.response.config.url.indexOf('/login') !== -1) {
    return Promise.reject(error.response);
  }
  loadingInstance && loadingInstance.close();
  let { status, data: { message }  } = error.response;
  if (!message) {
    switch (status) {
      case 401: message = '您没有权限访问此操作！';break;
      case 403: message = '您的登录状态已失效，请重新登录。';break;
      case 424: message = error.response.data.error;break;
      default: message = '请求失败！';
    }
  }
  Message({ message, type: 'error', onClose() {
    if (status == 401 || status == 403) {
      logout();
    }
  }});
});

// oauth路径的请求
export function loginFetch(options) {
  return new Promise((resolve, reject) => {
    var ObjAPI = store.getters.objApi;
    axios.post(ObjAPI.OAUTH_API + options.url, options.data, {
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      withCredentials: true,
      transformRequest: [function (data) {
        return qs.stringify(data);
      }]
    })
      .then((response) => {
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      })
  })
}

// base路劲的表单数据post
export function post(options) {
  return new Promise((resolve, reject) => {
    var ObjAPI = store.getters.objApi;
    axios.post(ObjAPI.BASE_API + options.url, options.data, {
      headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'},
      withCredentials: true,
      transformRequest: [function (data) {
        return qs.stringify(data);
      }]
    })
      .then((response) => {
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      })
  })
}

// base路劲的get请求
export function get(options) {
  return new Promise((resolve, reject) => {
    var ObjAPI = store.getters.objApi;
    axios.get(ObjAPI.BASE_API + options.url,{params: options.data}, {
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      withCredentials: true
    })
      .then((response) => {
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      })
  })
}

// base路劲的json数据post
export function postJson(options) {
  return new Promise((resolve, reject) => {
    var ObjAPI = store.getters.objApi;
    axios.post(ObjAPI.BASE_API + options.url, options.data, {
      headers: {'Content-Type': 'application/json'},
      withCredentials: true
    })
      .then((response) => {
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      })
  })
}

// base路劲的delete请求
export function deleteData(options) {
  return new Promise((resolve, reject) => {
    var ObjAPI = store.getters.objApi;
    axios.delete(ObjAPI.BASE_API + options.url, {params: options.data}, {
      headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'},
      withCredentials: true
    })
      .then((response) => {
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      })
  })
}

// base路劲put请求
export function put(options) {
  return new Promise((resolve, reject) => {
    var ObjAPI = store.getters.objApi;
    axios.put(ObjAPI.BASE_API + options.url, options.data, {
      headers: {"Accept":"*/*"},
      withCredentials: true,
      transformRequest: [function (data) {
        return qs.stringify(data);
      }]
    })
      .then((response) => {
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      })
  })
}

// base路劲的json数据delete
export function postJsonDelete(options) {
  return new Promise((resolve, reject) => {
    var ObjAPI = store.getters.objApi;
    axios.delete(ObjAPI.BASE_API + options.url, {data: options.data}, {
      headers: {'Content-Type': 'application/json'},
      withCredentials: true
    })
      .then((response) => {
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      })
  })
}


// WEBPACK FOOTER //
// ./src/utils/fetch.js